import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, ButtonGroup } from '@mui/material';
import { useCallback, useContext } from 'react';
import { isBreakpointMobile, useBreakpoint } from '../breakpoint';
import { CommonContext } from '../context/CommonContext';
import { OfflineBanner } from './OfflineBanner';
export const TodayYearButtons = ({ todayId, yearId, scrollIntoViewOptionsObject, }) => {
    const { isOnline } = useContext(CommonContext);
    const breakpoint = useBreakpoint();
    const isMobile = isBreakpointMobile(breakpoint);
    const todayToScrollTo = document.getElementById(todayId);
    const yearToScrollTo = document.getElementById(yearId);
    const onTodayClick = useCallback(() => {
        if (todayToScrollTo) {
            const element = document.getElementById(todayId);
            if (element) {
                element.scrollIntoView(scrollIntoViewOptionsObject);
            }
        }
    }, [scrollIntoViewOptionsObject, todayId, todayToScrollTo]);
    const onYearClick = useCallback(() => {
        if (yearToScrollTo) {
            const element = document.getElementById(yearId);
            if (element) {
                element.scrollIntoView(scrollIntoViewOptionsObject);
            }
        }
    }, [scrollIntoViewOptionsObject, yearId, yearToScrollTo]);
    return (_jsxs(Box, { sx: {
            display: 'flex',
            gap: 2,
            position: 'fixed',
            right: '1rem',
            top: '0.75rem',
            zIndex: 3,
            width: isMobile ? '50%' : '30%',
            justifyContent: 'flex-end',
        }, children: [!isOnline && (_jsx(OfflineBanner, { isOffline: !isOnline, dataTestId: 'top-bar-offline-banner', sx: { p: '4px 0', width: '50%' } })), _jsxs(ButtonGroup, { size: "small", sx: { height: '80%' }, children: [_jsx(Button, { "data-testid": 'calendar-today', variant: 'outlined', onClick: onTodayClick, children: "today" }), _jsx(Button, { "data-testid": 'calendar-year', variant: 'outlined', onClick: onYearClick, children: "year" })] })] }));
};
